export const getFormattedDate = (dateString: string): string => {
  const date = new Date(dateString);
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const day = date.getDate().toString().padStart(2, '0');
  const monthIndex = date.getMonth(); // Months are zero indexed
  const year = date.getFullYear();
  const formattedMonth = monthNames[monthIndex];
  return `${day} ${formattedMonth} ${year}`;
};

export function maskString(input?: string | null): string {
  if (input === null || input === undefined) {
    return '';
  }

  const maskedString = input.slice(0, 4) + '********' + input.slice(-4);
  return maskedString;
}

export const onlyShowLastDigits = (toMask: string, length: number): string => {
  try {
    const toShowDigits = toMask.slice(-length);
    const maskDigits = Array.from({ length: toMask.length - length }, (_, index) => '*');
    return maskDigits.join('') + toShowDigits;
  } catch (error) {
    console.log('Error while onlyShowLastDigits:', error);
    return '';
  }
};
